/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_CreatingInputs */

const vi_common_creating = /** @type {(inputs: Common_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tạo...`)
};

/**

* @param {Common_CreatingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_creating = /** @type {((inputs?: Common_CreatingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_CreatingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_creating(inputs)
});